import React, { useRef, useEffect } from 'react';

function NumberEditor({ value, onChange, disabled, onKeyDown }) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, []);

  return (
    <input
      ref={inputRef}
      type="number"
      className="field-editor-input"
      value={value ?? ''}
      onChange={(e) => {
        const val = e.target.value;
        onChange(val === '' ? null : Number(val));
      }}
      onKeyDown={onKeyDown}
      disabled={disabled}
    />
  );
}

export default NumberEditor;
